import React from 'react';
import ReactDOM from 'react-dom';
import components from "./config/components";
import CONST from "../config/CONST";

const boostrapper = () => {

    const domElements = document.querySelectorAll("[data-react-component]");
    domElements.forEach(function(el) {
        if(CONST.DEBUG) {
            console.log("React component <"+el.dataset.reactComponent+">: initializing...");
        }
        let ReactComponent = components[ el.dataset.reactComponent ];
        if (typeof ReactComponent !== "undefined") {
            let props = {};
            if(typeof el.dataset.props !== "undefined") {
                props = JSON.parse(el.dataset.props);
            }

            if(el.innerHTML !== "") {
                props.innerHTML = el.innerHTML;
            }

            ReactDOM.render(<ReactComponent {...props} />, el);
            el.classList.add("is-ready");
            if(CONST.DEBUG) {
                console.log("React component <"+el.dataset.reactComponent+">: initialized");
                console.log("React component <"+el.dataset.reactComponent+">: props", props);
            }
        }
        else {
            if(CONST.DEBUG) {
                console.warn("Component <"+el.dataset.reactComponent+">: not found");
            }
        }
    });

}

export default boostrapper;